export default __webpack_public_path__ + "images/Refund_Credited_Policy.svg";